<template>
  <div class="tbl_comm tbl_view">
    <div v-if="hasTblTop" class="tbl_top">
      <slot name="tbl_top"/>
    </div>
    <div v-if="hasTblBody" class="tbl_body">
      <table>
        <colgroup v-if="hasTblColgroup">
          <slot name="tbl_colgroup"/>
        </colgroup>
        <colgroup v-if="!hasTblColgroup">
          <col style="width:15%"/>
          <col style="width:35%" />
          <col style="width:15%" />
          <col style="width:35%" />
        </colgroup>
        <thead v-if="hasTblHead">
          <tr>
            <slot name="tbl_head"/>
          </tr>
        </thead>
        <tbody v-if="hasTblBody">
          <slot name="tbl_body"/>
        </tbody>
        <tfoot v-if="hasTblFoot">
          <slot name="tbl_foot"/>
        </tfoot>
      </table>
    </div>
    <div v-if="hasTblBottom" class="tbl_bottom">
      <slot name="tbl_bottom"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name:'TableView',
  computed:{
    ...mapGetters('commonViewport', [ 'getWindowWidth' ]),
    // isMobile(){
    //   return this.getWindowWidth <= 1240
    // },
    hasTblTop(){
      return this.$slots['tbl_top']
    },
    hasTblColgroup(){
      return this.$slots['tbl_colgroup']
    },
    hasTblHead(){
      return this.$slots['tbl_head']
    },
    hasTblBody(){
      return this.$slots['tbl_body']
    },
    hasTblFoot(){
      return this.$slots['tbl_foot']
    },
    hasTblBottom(){
      return this.$slots['tbl_bottom']
    },
  }

}
</script>

<style lang="scss" scoped>
.group_box_widget + .tbl_view{margin-top:40px}

// 공통
.tbl_view tr th,
.tbl_view tr td{padding:9px 20px;border:1px solid $DEFAULT_BORDER;font-size:14px;line-height:38px;vertical-align:top}

.tbl_view tr th{padding:16px 20px;line-height:24px;}

.tbl_view thead th,
.tbl_view tbody th,
.tbl_view tfoot th{font-weight:600}
.tbl_view thead th,
.tbl_view tfoot th{background-color:$TITLE_BG}
.tbl_view tbody th,
.tbl_view tfoot td{background-color:$TITLE_BG}
.tbl_view tbody th,
.tbl_view tfoot th{text-align:left}
.tbl_view tbody th,
.tbl_view tbody td{border:1px solid $DEFAULT_BORDER;}

.tbl_view tbody tr:first-child >*{border-top:0 none}
.tbl_view tbody tr:last-child >*{border-bottom:0 none}
.tbl_view tr > *:first-child{border-left:0 none}
.tbl_view tr > *:last-child{border-right:0 none}

.tbl_view thead tr th{border-top:0 none;border-bottom:1px solid $DEFAULT_BORDER}
.tbl_view tfoot th,
.tbl_view tfoot td{border-top:1px solid $DEFAULT_BORDER;border-bottom:0 none}

.tbl_view tbody th{color:$TITLE_TEXT}
.tbl_view tbody th .icon_essential{margin:4px 0 0 6px}
.tbl_view tbody th .txt_info{display:block;font-size:12px;line-height:14px;color:$CONTENT_SUB_TEXT}

// selected
.tbl_view tbody .tr_selected{position:relative}
.tbl_view tbody .tr_selected td{background-color:rgba($PRIMARY_COLOR,.1)}
.tbl_view tbody .tr_selected > *:first-child:before{position:absolute;top:-1px;left:0;bottom:0;width:2px;background-color:$PRIMARY_COLOR;content:''}
.tbl_view tbody .tr_selected > *:last-child:before{position:absolute;top:-1px;right:0;bottom:0;width:2px;background-color:$PRIMARY_COLOR;content:''}
.tbl_view tbody .tr_selected > *:first-child:after{position:absolute;top:-1px;left:0;right:0;height:2px;background-color:$PRIMARY_COLOR;content:''}
.tbl_view tbody .tr_selected > *:last-child:after{position:absolute;bottom:-1px;left:0;right:0;height:2px;background-color:$PRIMARY_COLOR;content:''}

.tbl_view tbody td{background-color:$DEFAULT_BG;color:$CONTENT_TEXT}

.tbl_view tbody td.td_center{text-align:center}
.tbl_view tbody td .txt_tbl{display:inline-block;padding:7px 0;line-height:20px;vertical-align:top;word-wrap:break-word;word-break:keep-all}
.tbl_view tbody td .txt_tbl.txt_break_all,
.tbl_view tbody td.txt_break_all .txt_tbl{word-break: break-all}
.tbl_view tbody td .selectbox_comm{display:block;max-width:100%}
.tbl_view tbody td .txt_center{display:inline-block;padding:0 8px;vertical-align:top}
.tbl_view tbody td .desc_info{display:block;margin-top:10px;font-weight:500;font-size:14px;line-height:18px;color:$CONTENT_SUB_TEXT;text-indent:-20px;padding-left:20px;word-wrap:break-word;word-break:keep-all}
.tbl_view tbody td .txt_tbl + .desc_info{margin-top:0}
.tbl_view tbody td .txt_tbl + .btn_xsmall{margin:4px 0 0 8px}
.tbl_view tbody td .desc_info:only-child{margin-top:0;padding:9px 0 9px 18px;line-height:20px}
.tbl_view tbody td .link_tbl{display:inline-block;padding:7px 0;line-height:20px;vertical-align:top;word-wrap:break-word;word-break:keep-all}
// point
.tbl_view ::v-deep .td_point .txt_tbl{padding:9px 12px;border-radius:4px;font-weight:700;background-color:$ACTIVE_BG_DARK;color:$CONTENT_TEXT_DARK}
// mark
.tbl_view ::v-deep .td_mark .txt_tbl{padding:9px 12px;border-radius:4px;font-weight:600;background-color:rgba($TERTIARY_COLOR,.8);color:$ACTIVE_TEXT}

// divide
.tbl_view .th_divide{background-image: linear-gradient( to top right, $TITLE_BG calc(50% - 1px), #ccc, $TITLE_BG calc(50% + 1px) )}
.tbl_view .th_divide .txt_divide{display:block;line-height:19px}
.tbl_view .th_divide .txt_divide:first-child{text-align:right}
.tbl_view .th_divide .txt_divide:last-child{text-align:left}

.board_comm + .tbl_view,
.fold_comm + .tbl_view,
.tbl_view + .tbl_view,
.group_tbl_view + .tbl_view{margin-top:40px}
.group_tbl_view > .tbl_view + .tbl_view{display:inline-block;margin-top:20px;box-sizing:border-box;vertical-align:top}

/* 모바일 */
// @media all and (max-width:1240px){
//   .tbl_view table > * {display:block}

//   .tbl_view table th,
//   .tbl_view table td{flex-grow:1;padding:0 0;border:0 none;box-sizing:border-box}
  
//   .tbl_view table th br{content: ' '}
//   .tbl_view table th br:after{content: ' '}

//   .tbl_view tr{display:flex;width:100%;flex-wrap:wrap}

//   .tbl_view thead{margin-bottom:20px}

//   .tbl_view thead th,
//   .tbl_view tfoot th{padding:8px 14px}

//   .tbl_view tfoot{margin-top:20px}

//   .tbl_view tbody tr + tr{margin-top:20px}
//   .tbl_view tbody tr th,
//   .tbl_view tbody tr td{display:block;flex:1 1 50%;max-width:50%}
//   .tbl_view tbody tr td{margin-top:4px;background:0 none}
//   .tbl_view tbody tr th{background:none}
//   .tbl_view tbody tr th:first-child{order:1}

//   .tbl_view tbody tr th:first-child + th{order:3}
//   .tbl_view tbody tr th:first-child + th + td{order:4}
//   .tbl_view tbody tr th:first-child + th + td + th{order:3}
//   .tbl_view tbody tr th:first-child + th + td + th + td{order:5}
//   .tbl_view tbody tr th:first-child + th + td{order:4}

//   .tbl_view tbody tr th:first-child + td{order:3}
//   .tbl_view tbody tr th:first-child + td + th{order:2}
//   .tbl_view tbody tr th:first-child + td + th + td{order:4}

//   .tbl_view tbody tr th[rowspan],
//   .tbl_view tbody tr th:only-of-type,
//   .tbl_view tbody tr td:only-of-type{flex:1 1 100%;max-width:100%}
//   .tbl_view tbody tr th[rowspan]{padding:18px 14px 18px;border-top:1px solid $DEFAULT_BORDER;font-size:18px;}
//   .tbl_view tfoot tr th,
//   .tbl_view tfoot tr td{flex:1 1 100%;max-width:100%}

//   .tbl_bottom{padding-top:16px;border-top:1px solid $DEFAULT_BORDER}
// }
@media (prefers-color-scheme: dark) {
  .tbl_view tr th,
  .tbl_view tr td{border-color:$DEFAULT_BORDER_DARK}
  
  .tbl_view thead th,
  .tbl_view tfoot th{background-color:$TITLE_BG_DARK}
  .tbl_view tbody th,
  .tbl_view tfoot td{background-color:$TITLE_BG_DARK}

  .tbl_view thead tr th{border-color:$DEFAULT_BORDER_DARK}
  .tbl_view tfoot th,
  .tbl_view tfoot td{border-color:$DEFAULT_BORDER_DARK}

  .tbl_view tbody th{color:$TITLE_TEXT_DARK}
  .tbl_view tbody th .txt_info{color:$CONTENT_SUB_TEXT_DARK}

  .tbl_view tbody td{background-color:$DEFAULT_BG_DARK;color:$CONTENT_TEXT_DARK}
  .tbl_view tbody td .desc_info{color:$CONTENT_SUB_TEXT_DARK}

  .tbl_view .th_divide{background-image: linear-gradient( to top right, #222 calc(50% - 1px), #000, #222 calc(50% + 1px) )}
}
</style>